
import Department from './department'

export default {
  namespaced: true,
  modules: {
    Department,
  }
}